module.exports = __webpack_public_path__ + "img/20.49644fe7.jpg";